import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { AdUnitBidderDTO } from 'features/globalSetup/api/types/adUnitBidderDTO'
import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'

export const AD_UNIT_BIDDER_FRAGMENT = (
  ability: Ability,
): TypedDocumentNode<AdUnitBidderDTO> => gql`
  ${ALERT_FRAGMENT}

  fragment AdUnitBidderFragment on AdUnitBidder {
    adUnit {
      ${permitFields<AdUnitBidderDTO['adUnit']>({
        ybAdUnitEnabled: ability.can('read', 'AdUnitField-ybAdUnitEnabled'),
      })}
      divId
      id
      path
    }
    csEnabled
    csParams
    fieldAlerts {
      ...AlertFragment
    }
    id
    s2sEnabled
    s2sParams
    updatedAt
  }
`
